import { cn, NoddiIcon } from 'noddi-ui-common';
import { NavioConfetti } from 'noddi-ui-web';
import { useRef } from 'react';
import { PageHeading } from '../Layouts/PageHeading';
import { TransitionCard } from '../Transition/TransitionCard';
import { TransitionScreenWrapper } from '../Transition/TransitionScreenWrapper';

export const BookingConfirmationIntro = ({
  className,
  iconClassName,
  title
}: {
  className?: string;
  iconClassName?: string;
  title: string;
}) => {
  const animationRef = useRef<HTMLDivElement>(null);

  return (
    <TransitionScreenWrapper className={cn('transition-opacity duration-500', className)}>
      <NavioConfetti triggerRef={animationRef} pieceCount={140} />
      <TransitionCard className='gap-10'>
        <PageHeading className='text-center text-3xl font-bold text-primary md:text-4xl'>{title}</PageHeading>

        <div
          ref={animationRef}
          className={cn(
            'flex items-center justify-center rounded-full bg-primary-background-gradient p-4 shadow-inner transition-transform duration-500',
            iconClassName
          )}
        >
          <NoddiIcon name='CircleCheck' size='xLarge' className='fill-primary text-white drop-shadow-xs' />
        </div>
      </TransitionCard>
    </TransitionScreenWrapper>
  );
};
